import { css } from "@emotion/react";

export const baseStyle = css`
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 20px;
  padding: 5px 8px;
`;

export const aFewLeftStyle = css`
  background-color: #d53f8c;
`;

export const soldOutStyle = css`
  background-color: #c2c2c2;
`;

export const beforeSaleStyle = css`
  background-color: #ffa200;
`;

export const endStyle = css`
  background-color: #c2c2c2;
`;

export const newStyle = css`
  background-color: #ffa200;
`;

export const onSaleStyle = css`
  background-color: #333333;
`;

// TODO: バリエーションとカラーは要確認 #10626のクローズまでに確認・反映する

// 発送系
export const preparingShipmentStyle = css`
  background-color: #333333;
`;

export const shippedStyle = css`
  background-color: #333333;
`;

// イベント系
export const beforeEventStyle = css`
  background-color: #333333;
`;

export const duringEventStyle = css`
  background-color: #333333;
`;

export const eventEndedStyle = css`
  background-color: #333333;
`;
